//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../Header";
//Install
import Footer from "../../Footer";
//Install
import T723BA from "../../../Media/Image/030.jpg";
//Install
import Y477FT from "../../../Media/Image/046.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Hakkımızda : Temas Elektrik Taahhüt"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Elektrik Taahhüt, Bakım ve Onarım, Proje Geliştirme, Enerji Sistemleri ve Otomasyon Alanlarında Deneyimli Kadromuz ve Yenilikçi Yaklaşımımızla Çözüm Üretiyoruz."
        //Element
        let URL = "https://temaselektrik.com/hakkimizda"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Hakkımızda"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "Elektriğe ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "Temas "
                                        ),
                                        //Element
                                        "Edin, Geleceğe Bağlanın."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik Taahhüt Enerji Sektöründe Güvenilir Çözümler Sunabilme Hedefiyle 1998 Yılında Kuruldu. Bugün, Elektrik Taahhüt, Bakım ve Onarım, Proje Geliştirme, Enerji Sistemleri ve Otomasyon Konularında Hizmet Sunmaktadır.",
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Kamu Kurumlarından Sanayi Tesislerine KOBİ'lerden Özel Projelere Kadar Kapsamlı Bir Ölçekte Hizmet Sunmaktadır. Tüm Çalışmalarında Sürdürülebilirlik ve Kalite İlkelerini Ön Planda Tutmaktadır."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Bizim İçin Her Kablo Sadece Bir Bağlantı Değil, Geleceğe Uzanan Sağlam Bir Hat ve Güvenli Yapılar İçin Temel Bir Değerdir. Tecrübemiz ve İnovatif Yaklaşımımız İle Her Projeyi Yarınlara Bırakılan Sağlam Bir Yatırım Haline Getiriyoruz."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        React.createElement("em", {},
                                            //Element
                                            "Temas Elektrik Taahhüt Limited Şirketi"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "Hakkımızda", title: "Hakkımızda", src: T723BA, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB a562nn" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB n8122j" },
                                    //Element
                                    React.createElement("img", { alt: "Temas Elektrik Taahhüt", title: "Temas Elektrik Taahhüt", src: Y477FT, width: "1296", height: "auto" })
                                )
                            )
                        )
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB x010yw" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB h4517j" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB u16155" },
                                        //Element
                                        "Misyonumuz"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x75t42" },
                                        //Element
                                        "Temas Elektrik Taahhüt Olarak; Elektriği Güvenli, Sürdürülebilir ve Verimli Çözümlerle Yöneterek, Her Projede Kalite, Güven ve Teknoloji Odaklı Çözümler Sunarak Geleceğe Değer Katmaktır."
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB h4517j" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB u16155" },
                                        //Element
                                        "Vizyonumuz"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x75t42" },
                                        //Element
                                        "Enerji Sektöründe Yenilikçi Teknolojiler ve Güvenilir Uygulamalarla Geleceğe Yön Veren Bir Marka Olmak ve Her Projede Sürdürülebilirliği, Kaliteyi ve Güveni Geleceğe Taşıyan Çözümler Üretmek."
                                    )
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;